import React, { useState, useEffect } from 'react';

/**
 * Component to display original HTML content from backup files
 * This can be used as a fallback or reference
 */
const HTMLViewer = ({ filename, title }) => {
  const [htmlContent, setHtmlContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadHTML = async () => {
      try {
        const response = await fetch(`/Backup/${filename}`);
        if (!response.ok) {
          throw new Error('Failed to load HTML file');
        }
        const html = await response.text();
        setHtmlContent(html);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    loadHTML();
  }, [filename]);

  if (loading) {
    return <div>Loading {title}...</div>;
  }

  if (error) {
    return <div>Error loading {title}: {error}</div>;
  }

  return (
    <div style={{ width: '100%', height: '100vh', border: 'none' }}>
      <iframe
        title={title}
        srcDoc={htmlContent}
        style={{ width: '100%', height: '100%', border: 'none' }}
        sandbox="allow-same-origin allow-scripts"
      />
    </div>
  );
};

export default HTMLViewer;

